"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeleteCustomerMutation = exports.useUpdateCustomerMutation = exports.useCreateCustomerMutation = exports.useLazyLookupCustomerQuery = exports.useLookupCustomerQuery = exports.useGetEntityNamesQuery = exports.useLazyGetOrganizationCustomersQuery = exports.useGetOrganizationCustomersQuery = exports.useGetCustomerQuery = exports.useLazyGetCustomersQuery = exports.useGetCustomersQuery = exports.customersApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.customersApi = (0, react_1.createApi)({
    reducerPath: "customersApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["Customers"],
    endpoints: function (builder) { return ({
        getCustomers: builder.query({
            query: function (params) { return ({
                url: "/v1/customers",
                params: params,
            }); },
            providesTags: function (result) {
                var _a;
                var customers = ((_a = result === null || result === void 0 ? void 0 : result.content) === null || _a === void 0 ? void 0 : _a.customers) || [];
                return customers.length > 0
                    ? __spreadArray(__spreadArray([], customers.map(function (_a) {
                        var _id = _a._id;
                        return ({
                            type: "Customers",
                            id: _id,
                        });
                    }), true), [
                        { type: "Customers", id: "LIST" },
                    ], false) : [{ type: "Customers", id: "LIST" }];
            },
        }),
        getCustomer: builder.query({
            query: function (id) { return "/v1/customers/".concat(id); },
            providesTags: function (result, error, id) { return [{ type: "Customers", id: id }]; },
        }),
        getOrganizationCustomers: builder.query({
            query: function (_a) {
                var organizationId = _a.organizationId, params = __rest(_a, ["organizationId"]);
                return ({
                    url: "/v1/organizations/".concat(organizationId, "/customers"),
                    params: params,
                });
            },
            providesTags: function (result, error, _a) {
                var organizationId = _a.organizationId;
                return [
                    { type: "Customers", id: "ORG_".concat(organizationId) },
                    { type: "Customers", id: "LIST" },
                ];
            },
        }),
        getEntityNames: builder.query({
            query: function (organizationId) {
                return "/v1/customers/organization/".concat(organizationId, "/entities");
            },
        }),
        lookupCustomer: builder.query({
            query: function (_a) {
                var organizationId = _a.organizationId, msisdn = _a.msisdn;
                return "/v1/customers/lookup/".concat(organizationId, "/").concat(msisdn);
            },
        }),
        createCustomer: builder.mutation({
            query: function (data) { return ({
                url: "/v1/customers",
                method: "POST",
                body: data,
            }); },
            invalidatesTags: function (result, error, data) { return [
                { type: "Customers", id: "LIST" },
                { type: "Customers", id: "ORG_".concat(data.organization_id) },
            ]; },
        }),
        updateCustomer: builder.mutation({
            query: function (_a) {
                var id = _a.id, data = _a.data;
                return ({
                    url: "/v1/customers/".concat(id),
                    method: "PATCH",
                    body: data,
                });
            },
            invalidatesTags: function (result, error, _a) {
                var id = _a.id;
                return [
                    { type: "Customers", id: id },
                    { type: "Customers", id: "LIST" },
                ];
            },
        }),
        deleteCustomer: builder.mutation({
            query: function (id) { return ({
                url: "/v1/customers/".concat(id),
                method: "DELETE",
            }); },
            invalidatesTags: [{ type: "Customers", id: "LIST" }],
        }),
    }); },
});
exports.useGetCustomersQuery = exports.customersApi.useGetCustomersQuery, exports.useLazyGetCustomersQuery = exports.customersApi.useLazyGetCustomersQuery, exports.useGetCustomerQuery = exports.customersApi.useGetCustomerQuery, exports.useGetOrganizationCustomersQuery = exports.customersApi.useGetOrganizationCustomersQuery, exports.useLazyGetOrganizationCustomersQuery = exports.customersApi.useLazyGetOrganizationCustomersQuery, exports.useGetEntityNamesQuery = exports.customersApi.useGetEntityNamesQuery, exports.useLookupCustomerQuery = exports.customersApi.useLookupCustomerQuery, exports.useLazyLookupCustomerQuery = exports.customersApi.useLazyLookupCustomerQuery, exports.useCreateCustomerMutation = exports.customersApi.useCreateCustomerMutation, exports.useUpdateCustomerMutation = exports.customersApi.useUpdateCustomerMutation, exports.useDeleteCustomerMutation = exports.customersApi.useDeleteCustomerMutation;
